import React from 'react';
import { pdf, DocumentProps } from '@react-pdf/renderer';
import { DetailedReport } from './DetailedReport';
import { DetailedReportData } from './detailedTypes';
import { saveBlob } from '../saveBlob';

export const generateDetailedPDF = async (
  data: DetailedReportData,
  filename: string
): Promise<void> => {
  const element = React.createElement(
    DetailedReport,
    { data }
  ) as React.ReactElement<DocumentProps>;
  const blob = await pdf(element).toBlob();
  await saveBlob(blob, filename);
};
